<template>
  <div class="modal" v-show="showPopup">
    <div class="close" @click="$emit('close')">
      <van-icon name="close" />
    </div>
    <div class="container">
      <div v-if="orderInfo.orderType === 9">
        <van-card v-for="(item, index) in orderInfo.orderServiceList" :key="index" :title="item.title" :desc="item.attrNorm" :num="item.num" :price="item.price" :thumb="item.picUrl">
          <div slot="footer">
            <van-rate v-model="scoreList[index]" color="#ed5c00" />{{scoreList[index] | scoreFilter}}
          </div>
        </van-card>
      </div>
      <div class="single-score" v-else>
        <van-rate v-model="score" color="#ed5c00" />
        <p>{{score | scoreFilter}}</p>
      </div>
      <div class="payFoot">
        <van-button size="large" type="danger" @click="postEvaluate" :loading="loading">提交</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { Toast } from 'vant';

export default {
  props: {
    showPopup: {
      type: Boolean,
      required: true
    },
    orderInfo: {
      required: true
    },
  },
  data(){
    return{
      score: 0,
      scoreList:[],
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['token']),
  },
  methods: {
    postEvaluate(){
      let params = {
        orderId: this.orderInfo.orderId
      }
      if(this.orderInfo.orderType === 9){
        let foodScore = [];
        this.orderInfo.orderServiceList.map((item, index) => {
          if(this.scoreList[index]>0){
            foodScore.push({foodId:item.foodId, score:this.scoreList[index]});
          }
        })
        if(foodScore.length < this.orderInfo.orderServiceList.length){
          Toast.fail({ duration: 1000, message: '请评价各个商品' });
          return;
        }
        params.foodScore = foodScore;
      }else{
        if(!this.score){
          Toast.fail({ duration: 1000, message: '请选择满意度' });
          return;
        }
        params.score = this.score;
      }

      //提交评价
      this.loading = true;
      this.$http.post(`${this.URL_PREFIX}/app/score/user/order/info`, params, {
        headers: { token: this.token },
      }).then((res) => {
        this.loading = false;
        if(res.data.resCode === '10000') {
          Toast.success({ duration: 1500, message: '提交成功' })
          this.$emit('close', true);
        }else{
          Toast.fail({ duration: 1500, message: res.data.resDesc });
        }
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss';
.modal {
  @include modify_info;
}
.payFoot{
  padding: .133333rem .5rem;
  text-align: center;
}
.single-score{
  text-align: center;
  padding: 1rem;
  p{
    padding: .5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OrderEvaluate.vue